module.exports = __webpack_public_path__ + "static/media/2.cb246795.png";